import { Controller } from "@hotwired/stimulus"

// Automatically triggers window.print() when connected to the DOM.
// Usage: <div data-controller="auto-print">
// A button inside the scope can re-trigger it: data-action="auto-print#print"
export default class extends Controller {
  connect() {
    window.print()
  }

  print() {
    window.print()
  }
}
